import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  idVariant?: string
  className?: string
}

function Calendar({ idVariant = '', className }: Props) {
  return (
    <IconBase name="calendar" w={24} className={className}>
      <rect x="3.5" y="6.5" width="17" height="13" stroke="currentColor"/>
      <path d="M7 7V4M17 7V4" stroke="currentColor"/>
      <line x1="4" y1="10.5" x2="20" y2="10.5" stroke="currentColor"/>
    </IconBase>
  )
}

export default Calendar
